import React, { useState } from 'react';
import { useMapEvents, Marker } from 'react-leaflet';
import L from 'leaflet';



const AddPoiMarker = (props) => {
  const [position, setPosition] = useState(props.default || null);

  useMapEvents({
    click(e) {
      setPosition(e.latlng);
      props.onMapClick(e.latlng);
    }
  });

  return position === null ? null : (
    <Marker position={position}>
    </Marker>
  );
};

export default AddPoiMarker;
